import { CountryRiskBadgesProps } from 'modules/client/common/feature';

export enum HeadType {
  legal = 'legal',
  person = 'person',
}

export enum HeadOptionType {
  delete = 'delete',
  archive = 'archive',
  dearchive = 'dearchive',
}
export interface HeadItem {
  id: string;
  name: string;
  position?: string;
  type: HeadType;
  country?: HeadItemCountry;
  countryRisk?: CountryRiskBadgesProps;
  archived: boolean;
  expirationDate?: string;
  createdAt: Date;
}

export interface HeadItemCountry {
  [HeadType.person]?: string;
  [HeadType.legal]?: string;
}
